import axios from 'axios'
import { TransferInitiationWebDto } from './types'
import { TIF_API, WITH_CREDENTIALS_CONFIG } from './constants'

export const initiateTransfer = (submission: TransferInitiationWebDto) =>
  axios.post(TIF_API, submission, WITH_CREDENTIALS_CONFIG)
